import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { LOCAL_STORAGE_APPLE_PAY_AVAILABLE } from 'constants/local-storage';

export const selectApplePayAvailable = () => readLocalStorage(LOCAL_STORAGE_APPLE_PAY_AVAILABLE) === true;
export const setApplePayAvailable = value => writeLocalStorage(LOCAL_STORAGE_APPLE_PAY_AVAILABLE, value);
